var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/emoji/emoji.tsx";
const _excluded = ["emoji", "alt"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { removeVS16s, toCodePoints } from 'soapbox/utils/emoji';
import { joinPublicPath } from 'soapbox/utils/static';
/** A single emoji image. */
const Emoji = props => {
  const {
      emoji,
      alt
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const codepoints = toCodePoints(removeVS16s(emoji));
  const filename = codepoints.join('-');
  if (!filename) return null;
  return /*#__PURE__*/React.createElement("img", _extends({
    draggable: "false",
    alt: alt || emoji,
    src: joinPublicPath(`packs/emoji/${filename}.svg`)
  }, rest, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }));
};
export default Emoji;